export enum InvoiceDiscountMode {
  None = 'none',
  ByItem = 'byItem',
  Global = 'global',
}
